import { InputBase, Typography, Button } from "@mui/material"
import { useEffect, useState } from "react"


export default function CustomForm({ status, message, onValidated, setError, setSuccess, setOpenForm }) {
    
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [project, setProject] = useState("")
    const [projectDescription, setProjectDescription] = useState("")

    function handleSubmit(e) {
        if(!name || !email || !project || !projectDescription) {
            setError("Please ensure all sections are complete.")
        } else if (email.indexOf("@") === -1) {
            setError("Please ensure you are using a valid email address.")
        } else{
            e.preventDefault()
            name &&
            email &&
            project &&
            projectDescription &&
            email.indexOf("@") > -1 &&
            onValidated({
                MERGE1: name,
                MERGE0: email,
                MERGE2: project,
                MERGE3: projectDescription
            })
        }
    }

    function clearFields() {
        setName("")
        setEmail("")
        setProject("")
        setProjectDescription("")
    }

    useEffect(() => {
        if(status === "success") {
            setOpenForm(false)
            clearFields()
        } 
    }, [status])

    useEffect(() => {
        if(status === "error") {
            setSuccess("")
            setError(message)
        } else if(status === "sending") {
            setSuccess("Submitting form...")
        } else {
            setSuccess(message)
        }
    }, [status, message])
    
    return(
        <form>
            <div className="modal-intro pool">
                <p className="modal-title">KwilV2 Early Access</p>
                <Typography
                    sx={{
                        margin: "22px 32px 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Name
                </Typography>
                <InputBase
                    label="Name"
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    value={name}
                    placeholder="Name"
                    required
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                        
                    }}
                />
                <Typography
                    sx={{
                        margin: "22px 32px 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Email
                </Typography>
                <InputBase
                    label="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    value={email}
                    placeholder="Email Address"
                    required
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                    }}
                />
                <Typography
                    sx={{
                        margin: "22px 32px 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Project Name
                </Typography>
                <InputBase
                    label="Project"
                    onChange={(e) => setProject(e.target.value)}
                    type="project"
                    value={project}
                    placeholder="Project Name"
                    required
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                    }}
                />
                <Typography
                    sx={{
                        margin: "22px 32px 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Brief Project Description
                </Typography>
                <InputBase
                    label="Description"
                    onChange={(e) => setProjectDescription(e.target.value)}
                    type="description"
                    value={projectDescription}
                    placeholder="Project Description"
                    required
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                    }}
                />
                <Button
                    type="submit"
                    sx={{
                        color: "#fff",
                        background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                        opacity: "0.9",
                        textTransform: "none",
                        margin: "40px auto",
                        borderRadius: "9px",
                        width: "19.028vw",
                        height: "49px",
                        fontFamily: "Averta",
                        fontWeight: "400",
                        fontSize: "20px",
                        lineHeight: "24px"
                      }}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
            </div>
        </form>
    )
}